import { Checkbox, Grid, IconButton, Stack, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import SaveIcon from "@mui/icons-material/Save";
import { DataGrid } from "@mui/x-data-grid";
import { useDispatch, useSelector } from "react-redux";
import CancelIcon from "@mui/icons-material/Cancel";
import DialogBoxComp from "../../../components/common/DialogBox/DialogBoxComp";
import ScreenCard from "../../../components/common/ScreenCard/ScreenCard";
import TableComp from "../../../components/common/TableComp/TableComp";
import InputWithBtnLayoutComp from "../../../components/InputWithBtnLayout/InputWithBtnLayoutComp";
import InputComp from "../../../components/common/InputComp/Input";
import TabComp from "../../../components/TabsComp/TabComp";
import Btn from "../../../components/common/ButtonComp/Btn";
import { asyncStatus } from "../../../utils/asyncStatus";
import { primaryColor } from "../../../utils/themeColors";
import {
  addOMPaymentTermAsync,
  deleteOMPaymentTermAsync,
  editOMPaymentTermAsync,
  getOMPaymentTermAsync,
} from "../../../store/services/orderManagementService";
const PaymentTerm = () => {
  const dispatch = useDispatch();
  const {
    getOMPaymentTermStatus,
    getOMPaymentTermError,
    getOMPaymentTermData,
    addOMPaymentTermStatus,
    addOMPaymentTermData,
    addOMPaymentTermError,

    editOMPaymentTermStatus,
    editOMPaymentTermError,
    editOMPaymentTermData,

    deleteOMPaymentTermData,
    deleteOMPaymentTermStatus,
    deleteOMPaymentTermError,
  } = useSelector((state) => state.om);

  useEffect(() => {
    dispatch(getOMPaymentTermAsync());
  }, []);

  // console.log("getProductStyleData", getProductStyleData);
  const formattedData = getOMPaymentTermData?.length
    ? getOMPaymentTermData.map((style, index) => ({
        id: index + 1, // Assuming the index is a unique identifier for each row
        ...style,
      }))
    : [];
  const [selectedPaymentTerm, setSelectedPaymentTerm] = useState();
  const [addPaymentTermMode, setAddPaymentTermMode] = useState(false);
  const [addPaymentTermData, setAddPaymentTermData] = useState();
  const [saveDisabled, setSaveDisabled] = useState(true);
  const [editData, setEditData] = useState();
  const [editMode, setEditMode] = useState(false);
  // console.log("selectedPaymentTerm", selectedPaymentTerm);
  // console.log("editData", editData);
  useEffect(() => {
    if (addOMPaymentTermStatus === asyncStatus.SUCCEEDED) {
      setAddPaymentTermMode(false);
      setSaveDisabled(true);
      setAddPaymentTermData();
    }
  }, [, addOMPaymentTermStatus]);

  const [open, setOpen] = useState(false);
  const agree = () => {
    dispatch(deleteOMPaymentTermAsync(selectedPaymentTerm?.term_id));
  };
  const handleClose = () => {
    setOpen(false);
  };
  useEffect(() => {
    if (deleteOMPaymentTermStatus === asyncStatus.SUCCEEDED || deleteOMPaymentTermStatus === asyncStatus.ERROR ) {
      setOpen(false);
      setSelectedPaymentTerm();
    }
  }, [, deleteOMPaymentTermStatus]);
  useEffect(() => {
    if (editOMPaymentTermStatus === asyncStatus.SUCCEEDED) {
      setSelectedPaymentTerm();
      setEditMode(false);
      setEditData()
    }
  }, [, editOMPaymentTermStatus]);

  //   const [tableHeight, setTableHeight] = useState("");
  //   let elem = document.getElementById("containerHeight");
  //   useEffect(() => {
  //     console.log("elem?.offsetHeight",elem?.clientHeight);
  //     setTableHeight(elem?.offsetHeight);
  //   }, [ elem?.offsetHeight]);
  // console.log(containerHeight)
  return (
    <Stack padding={2}>
      <DialogBoxComp
        open={open}
        handleClose={handleClose}
        agree={agree}
        innerContent={"Are you sure you want to delete this payment term?"}
        heading={"Delete request"}
      />
      <ScreenCard
        title="Payment Term"
        customHeader={
          <Stack
            sx={{
              padding: 0.5,
              px: 4,
              backgroundColor: primaryColor,
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography sx={{ color: "white", fontWeight: "bold" }}>
              Payment Term
            </Typography>
            <Stack flexDirection={"row"} gap={1}>
              <IconButton
                onClick={() => {
                  setEditMode(false);
                  setAddPaymentTermMode((prev) => !prev);
                  setSaveDisabled(false);
                }}
              >
                {!addPaymentTermMode ? (
                  <AddIcon sx={{ color: "white" }} />
                ) : (
                  <CancelIcon sx={{ color: "white" }} />
                )}
              </IconButton>
              <IconButton
                disabled={addPaymentTermMode}
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => {
                  setAddPaymentTermMode(false);
                  setEditMode((prev) => !prev);
                  setSaveDisabled(false);
                }}
              >
                {!editMode ? (
                  <EditIcon />
                ) : (
                  <CancelIcon sx={{ color: "white" }} />
                )}
              </IconButton>
              <IconButton
                disabled={addPaymentTermMode || !selectedPaymentTerm}
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => setOpen(true)}
              >
                <DeleteIcon />
              </IconButton>
              <IconButton
                disabled={
                  addOMPaymentTermStatus === asyncStatus.LOADING ||
                  editOMPaymentTermStatus === asyncStatus.LOADING ||
                  saveDisabled
                }
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => {
                  if (addPaymentTermData) {
                    dispatch(addOMPaymentTermAsync(addPaymentTermData));
                  } else if (editMode) {
                    let a;
                    a = { ...selectedPaymentTerm, ...editData };
                    delete a.id;
                    dispatch(editOMPaymentTermAsync(a));
                  }
                }}
              >
                <SaveIcon />
              </IconButton>
            </Stack>
          </Stack>
        }
      >
        <Grid container>
          <Grid item xl={3} lg={3} md={3} sm={12} xs={12}>
            <Stack height={500} width={"100%"}>
              <TableComp
                columns={[
                  { field: "term_id", headerName: "ID", flex: true },
                  { field: "term_name", headerName: "Payment Term", flex: true },
                ]}
                onRowClick={(e) => {
                  setSelectedPaymentTerm(e?.row);
                }}
                rows={formattedData}
                loading={
                  getOMPaymentTermStatus === asyncStatus.IDLE ||
                  getOMPaymentTermStatus === asyncStatus.LOADING
                }
              />
            </Stack>
          </Grid>
          <Grid item xl={9} lg={9} md={9} sm={12} xs={12} padding={2}>
            {addPaymentTermMode ? (
              <InputWithBtnLayoutComp
              error={addOMPaymentTermError}
                inputArray={[
                  {
                    label: "Payment Term:",
                    comp: (
                      <InputComp
                        style={{ borderRadius: 5, fontSize: 12, padding: 4 }}
                        placeholder=""
                        onChange={(e) =>
                          setAddPaymentTermData({
                            ...addPaymentTermData,
                            term_name: e.target.value,
                          })
                        }
                      />
                    ),
                  },
                  {
                    label: "Active:",
                    comp: (
                      <Checkbox
                        defaultChecked
                        defaultValue={true}
                        onChange={(e) =>
                          setAddPaymentTermData({
                            ...addPaymentTermData,
                            is_active: e.target.checked,
                          })
                        }
                      />
                    ),
                  },
                ]}
                secondaryComp={<></>}
              />
            ) : selectedPaymentTerm ? (
              <InputWithBtnLayoutComp
              error={editOMPaymentTermError}
                inputArray={[
                  {
                    label: "ID:",
                    comp: (
                      <Typography sx={{ fontSize: 14 }}>
                        {selectedPaymentTerm?.term_id}
                      </Typography>
                    ),
                  },
                  {
                    label: "Payment Term:",
                    comp: (
                      <InputComp
                        key={selectedPaymentTerm?.term_id} // Add key prop to force remount
                        disabled={!editMode}
                        onChange={(e) =>
                          setEditData({
                            ...editData,
                            term_name: e.target.value,
                          })
                        }
                        style={{ borderRadius: 5, fontSize: 12, padding: 4 }}
                        placeholder=""
                        defaultValue={selectedPaymentTerm?.term_name}
                      />
                    ),
                  },
                  {
                    label: "Active:",

                    comp: (
                      <Checkbox
                        onChange={(e) =>
                          setEditData({
                            ...editData,
                            is_active: e.target.checked,
                          })
                        }
                        value={selectedPaymentTerm?.is_active|| editData?.is_active}
                        disabled={!editMode}
                        // defaultValue={selectedPaymentTerm?.is_active || editData?.is_active}
                        defaultChecked={selectedPaymentTerm?.is_active || editData?.is_active}
                        // checked={selectedPaymentTerm?.is_active}
                      />
                    ),
                  },
                ]}
                secondaryComp={
                  <Btn
                    style={{ fontSize: 10, fontWeight: "bold" }}
                    disabled={editMode}
                  >
                    Assign Companies
                  </Btn>
                }
              />
            ) : (<Stack>
              <Typography>Select any payment term</Typography>
              <Typography color={"red"} fontSize={12}>{getOMPaymentTermError}</Typography>
            </Stack>
            )}
            <Stack my={2}>
              <TabComp
                tabs={[
                  //   {
                  //     name: "Companies",
                  //     content: (
                  //       <Stack height={400} width={"100%"}>
                  //         <TableComp
                  //           columns={[
                  //             {
                  //               field: "companyId",
                  //               headerName: "Company ID",
                  //               flex: true,
                  //             },
                  //             {
                  //               field: "companyName",
                  //               headerName: "Company Name",
                  //               flex: true,
                  //             },
                  //             {
                  //               field: "action",
                  //               headerName: "Action",
                  //               flex: true,
                  //             },
                  //           ]}
                  //           //   onRowClick={(e) => {
                  //           //     setSelectedPaymentTerm(e?.row);
                  //           //   }}
                  //           rows={[]}
                  //           //   loading={
                  //           //     getProductStyleStatus === asyncStatus.IDLE ||
                  //           //     getProductStyleStatus === asyncStatus.LOADING
                  //           //   }
                  //         />
                  //       </Stack>
                  //     ),
                  //   },
                  {
                    name: "Log Info",
                    content: (
                      <Stack height={400} width={"100%"}>
                        <TableComp
                          columns={[
                            {
                              field: "logId",
                              headerName: "Log ID",
                              flex: true,
                            },
                            {
                              field: "recordId",
                              headerName: "Record_id",
                              flex: true,
                            },
                            {
                              field: "columnName",
                              headerName: "Column Name",
                              flex: true,
                            },
                            {
                              field: "columnValue",
                              headerName: "Column Value",
                              flex: true,
                            },
                            {
                              field: "actionName",
                              headerName: "Action Name",
                              flex: true,
                            },
                            {
                              field: "actionDate",
                              headerName: "Action Date",
                              flex: true,
                            },
                            {
                              field: "userId",
                              headerName: " User ID",
                              flex: true,
                            },
                          ]}
                          //   onRowClick={(e) => {
                          //     setSelectedPaymentTerm(e?.row);
                          //   }}
                          rows={[]}
                          //   loading={
                          //     getProductStyleStatus === asyncStatus.IDLE ||
                          //     getProductStyleStatus === asyncStatus.LOADING
                          //   }
                        />
                      </Stack>
                    ),
                  },
                ]}
              />
            </Stack>
          </Grid>
        </Grid>

        {/* <div style={{ height: 400, width: '100%' }}>
      <DataGrid
      sty
        rows={rows}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: 5 },
          },
        }}
        pageSizeOptions={[5, 10]}
        // checkboxSelection
      />
    </div> */}
      </ScreenCard>
    </Stack>
  );
};

export default PaymentTerm;
